import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { getAccessLevelDisplayName, canManageOrganizations, canManageMarketplaces } from '../../auth/Auth';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import { useDashboardState } from './hooks/useDashboardState';
import { DashboardTabs } from './components/DashboardTabs';
import { DashboardFilters } from './components/DashboardFilters';
import { DashboardContent } from './components/DashboardContent';
import { SalesDashboardProvider } from './context/SalesDashboardProvider';
import styles from './DashboardComponent.module.scss';

export const DashboardComponent: React.FC = () => {
    const { auth } = useSelector((state: RootState) => state.login);

    // Use custom hook for all dashboard state management
    const {
        selectedTab,
        setSelectedTab,
        expandedDropdowns,
        handleDropdownToggle,
        handleDropdownClose,
        getMetricsData
    } = useDashboardState();

    const getUserDisplayName = () => {
        if (!auth?.user) return 'User';
        return `${auth.user.firstName} ${auth.user.lastName}`.trim() || auth.user.email;
    };

    const getWelcomeMessage = () => {
        const accessLevel = getAccessLevelDisplayName();
        return `Welcome back, ${getUserDisplayName()}! You have ${accessLevel} access.`;
    };

    return (
        <div className={styles.dashboardComponent}>
            {/* Dashboard Header */}
            <DefaultHeader
                title="Dashboard"
                className={styles.dashboardHeader}
            />

            {/* Main Tabs Selection */}
            <DashboardTabs
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
            />

            {/* Filters Row */}
            <SalesDashboardProvider>
                <DashboardFilters
                    expandedDropdowns={expandedDropdowns}
                    onDropdownToggle={handleDropdownToggle}
                    onDropdownClose={handleDropdownClose}
                />

                {/* Dynamic Tab Content */}
                <DashboardContent
                    selectedTab={selectedTab}
                    metrics={getMetricsData()}
                />
            </SalesDashboardProvider>

            {/* Permission-based Action Cards 
            <div className={styles.actionsGrid}>
                {canManageOrganizations() && (
                    <div className={styles.actionCard}>
                        <h3>Organization Management</h3>
                        <p>Create and manage organizations, set up hierarchies, and configure access levels.</p>
                    </div>
                )}

                {canManageMarketplaces() && (
                    <div className={styles.actionCard}>
                        <h3>Marketplace Management</h3>
                        <p>Create marketplaces, configure services, and manage business operations.</p>
                    </div>
                )}

                <div className={styles.actionCard}>
                    <h3>Service Catalog</h3>
                    <p>Browse and manage the service catalog, create templates, and configure add-ons.</p>
                </div>

                <div className={styles.actionCard}>
                    <h3>Analytics & Reports</h3>
                    <p>View performance metrics, generate reports, and analyze platform usage.</p>
                </div>
            </div>
            */}
        </div>
    );
};

export default DashboardComponent;
